import { Text, Field } from '@sitecore-jss/sitecore-jss-nextjs';
import { useState } from 'react';

import styles from './SidePanel.module.scss';

export interface SidePanelProps {
  children?: React.ReactNode;
  tabLabel?: Field<string>;
}

const SidePanel = ({ tabLabel, children }: SidePanelProps): JSX.Element => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleSidePanel = () => {
    setIsOpen((prevState) => !prevState);
  };

  return (
    <>
      <div id="side-navigation-container" className={`${styles['container']}`}>
        <button
          id="side-navigation-tab"
          className={`${styles['tab']} ${isOpen && styles['open']}`}
          onClick={toggleSidePanel}
          aria-label={isOpen ? 'Close panel' : 'Open panel'}
        >
          <Text className={styles[`tab-label`]} field={tabLabel} tag="p" />
          <i className={`bi bi-text-indent-${isOpen ? 'right' : 'left'} ${styles['tab-icon']}`} />
        </button>

        <div className={`${styles['panel']} ${isOpen && styles['open']}`}>
          <div className={styles.content}>
            <button
              onClick={() => setIsOpen(false)}
              className={`btn btn-naked ${styles['close-icon']}`}
              aria-label="Side Navigation menu close button"
            >
              <i className="bi bi-x" aria-hidden={true} />
            </button>
            {children}
          </div>
        </div>
      </div>
    </>
  );
};

export default SidePanel;
